import { IonAvatar } from "@ionic/react";

import avatar from "../assets/avatar.svg";
import "./ProfileImage.css";

export interface Profile {
  url?: string;
}

interface ProfileImageProps {
  profile?: Profile;
  onSelect?: (profile: Profile) => void;
  onError?: () => void;
}

const ProfileImage: React.FC<ProfileImageProps> = ({
  profile,
  onSelect,
  onError,
}) => {
  return (
    <IonAvatar
      className="profile-image"
      onClick={() => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        onSelect && profile && onSelect(profile);
      }}
    >
      <img
        src={profile?.url ? profile.url : avatar}
        onError={(e) => {
          (e.target as HTMLImageElement).src = avatar;
          onError?.();
        }}
      />
    </IonAvatar>
  );
};

export default ProfileImage;
